import React from 'react';
import { Button, ButtonProps, ComponentWithAs, forwardRef } from '@chakra-ui/react';
import { ResultProps } from '../../../type';
import { Link as RouterLink } from 'react-router-dom';

const FindRestaurantButton: ComponentWithAs<'button', ButtonProps & ResultProps> = forwardRef<
  ButtonProps & ResultProps,
  'button'
>((props, ref) => {
  return (
    <Button as={RouterLink} to={'/restaurant/' + props.food.name} ref={ref} {...props}>
      음식점 찾기
    </Button>
  );
});

export default FindRestaurantButton;
